// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MacCommandOutlinedSvg from "@ant-design/icons-svg/es/asn/MacCommandOutlined";
import AntdIcon from '../components/AntdIcon';

var MacCommandOutlined = function MacCommandOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MacCommandOutlinedSvg
  }));
};

MacCommandOutlined.displayName = 'MacCommandOutlined';
export default React.forwardRef(MacCommandOutlined);